// formrefs.js
// https://stackoverflow.com/a/21522742
// https://curiosity-driven.org/private-properties-in-javascript  <--- This is amazing! --> Research `WeakMap`!

/* Other tests
  var func = (var2in) => { return (function(varIn){return varIn;}(var2in)) };
  var z = func((someval)=>{console.log(someval);})
  z(9999)
  // Outputs `9999` in the console.
*/

const formRefs = (function() {
  // ⬇ This inner function *MUST* be this `function` key word declaration or it doesn't `return` as the proper callable type. See links above.
  function formRefs() {
    var instance = {};

    this.create = (name,refObj,val) => {
      if (!refObj || !refObj.hasOwnProperty("current")) {
        console.error(`Creating a formref for '${name}', the second parameter must be 'useRef()'.`);
        throw new Error(`Creating a formref for '${name}', the second parameter must be 'useRef()'.`);
        // return false;
      }
      if (!(name in instance) || !instance[name].current) {
        instance[name] = refObj;
        // Only update val on INITIAL Create, not on each re-render when it already exists. Bad things happen.
        if (typeof(val) !== "undefined" && val!==null) {
          window.setTimeout(() => {  // Time for the ref to be attached to the input.
            if (!!instance[name] && !!instance[name].current) {
              this.set(name,val);
            }
          },1); // after it's attached to the form input!
        }
        window.setTimeout(() => {  // Time for the ref to be attached to the input.
          let _targetRef = this.getRef(name);
          if (!!_targetRef && !!_targetRef.current) {
            _targetRef.current.isFormRef = true;
            _targetRef.current.formRefName = name;
          }
        },1); // after it's attached to the form input!
      }
      return instance[name];
    };
    this.get = (name) => {
      if (!(name in instance)) {
        return null;
      }
      if (!("current" in instance[name])) {
        return null;
      }
      let returnVal = "";
      let inputType = (instance[name].current?.type || instance[name].current?.viewConfig?.baseModuleName) || "unknown";
      if (inputType.toLowerCase().indexOf("checkbox") > -1 || inputType.toLowerCase().indexOf("rctview") > -1) {
        returnVal = instance[name].current.checked;
      } else if (inputType.toLowerCase().indexOf("text") > -1 && !!instance[name].current?.value) {
        returnVal = (typeof(instance[name].current.value)==="string" ? instance[name].current.value.trim() : instance[name].current.value);
      } else if (!!instance[name].current?.value) {
        returnVal = instance[name].current.value;
      }
      return returnVal;
    };
    this.getRef = (name) => {
      if (!(name in instance)) {
        return null;
      }
      if (!("current" in instance[name])) {
        return null;
      }
      return instance[name];
    };
    this.set = (name, val) => {
      if (!(name in instance)) {
        return null;
      }
      let inputType = (instance[name].current?.type || instance[name].current?.viewConfig?.baseModuleName) || "unknown";
      if (inputType.toLowerCase().indexOf("checkbox") > -1 || inputType.toLowerCase().indexOf("rctview") > -1) {
        if (!!instance[name].current?.setChecked) {
          instance[name].current.setChecked(val);  // swap bool state to match intended val
        // } else {
        //   instance[name].current.value = val;  // swap bool state to match intended val
        }
        return val;
      }
      // Check for React-Native event driven updates:
      if (!!val && typeof(val) === "object" && "nativeEvent" in val) {
        val = val.nativeEvent.text;
      }
      // if (typeof(val) === "string") {  // This blocks pressing spacebar because it's triggered on every key press.
      //   val = val.trim();
      // }
      if (!!instance[name].current) {
        instance[name].current.value = val;
        // instance[name].current.setNativeProps({ text: val });
      }
      return val;
    };
    this.disabled = (name,tf) => {
      Object.keys(instance).forEach(name => { instance[name].current.disabled = tf;} );
    };
    this.clear = () => {
      Object.keys(instance).forEach(name => { instance[name].current.clear();} );
    };
    this.getAll = () => {
      var refValuesObj = {};
      Object.keys(instance).forEach(name => {
        refValuesObj[name] = this.get(name);
      });
      return refValuesObj;
    };
    this.setAll = (obj) => {
      if (!!obj && typeof(obj)==="object" && Object.keys(obj).length) {
        Object.keys(obj).forEach(key => { this.set(key,obj[key]) });
        return true;
      }
      return false;
    };
    this.disableAll = () => {
      Object.keys(instance).forEach(name => { instance[name].current.disabled = true; } );
    };
    this.enableAll = () => {
      Object.keys(instance).forEach(name => { instance[name].current.disabled = false;} );
    };
    this.getAllRefs = () => {
      var refsObj = {};
      Object.keys(instance).forEach(name => { refsObj[name] = this.getRef(name); });
      return refsObj;
    };
    this.getAllRefKeys = () => {
      return Object.keys(instance)
    };
    this.delete = (name) => {
      if (name in instance) {
        delete instance[name];
        return true;
      }
      return false;
    };
    this.deleteAll = () => {
      instance = {};
      return true;
    };
    this.debug = () => {
      return instance;
    };
  };

  return formRefs;

}());

// export default new formRefs();  // NOT HERE! That would make a `singleton` which is then shared between ALL instances, we need separate instances in the callers.
export default formRefs;